<form [formGroup]="createForm" class="form-validation" (ngSubmit)="onSubmit()">
  <div class="modal-header">
    <h4 class="modal-title pull-left" style="text-transform: uppercase;">{{modalTitle}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <div class="row">

      <ng-template #ErrorMsg let-msg="msg" let-value="value" let-submitted="submitted">
        <div *ngFor="let validation of msg">
          <div class="error-message"
            *ngIf="value.hasError(validation.type) && (value.touched || value.dirty || submitted)">
            {{validation.message}}
          </div>
        </div>
      </ng-template>

      <!-- Code -->
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ lang?.projectCode }}</label>
        </div>
        <div class="form-group col-sm-9">
          <input type="text" class="form-control" formControlName="code"
            [ngClass]="formErrorClass(createForm.controls.code, createFormSubmitted)">
          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.code, value:createForm.controls.code, submitted:createFormSubmitted }"
            >
          </ng-template>
        </div>
      </div>

      <!-- Title -->
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ lang?.projectTitle }}</label>
        </div>
        <div class="form-group col-sm-9">
          <input type="text" class="form-control" formControlName="title"
            [ngClass]="formErrorClass(createForm.controls.title, createFormSubmitted)">
          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.title, value:createForm.controls.title, submitted:createFormSubmitted }"
            >
          </ng-template>
        </div>
      </div>  
      
      <!-- Customer -->
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ lang?.customer }}</label>
        </div>
        <div class="form-group col-sm-9">
          <!-- <input type="text" class="form-control" formControlName="customer_id"
            [ngClass]="formErrorClass(createForm.controls.customer_id, createFormSubmitted)"> -->
            <ng-multiselect-dropdown formControlName="customer_id" [data]="customerList" [(ngModel)]="selectedItems"
            [settings]="dropdownSettings">
          </ng-multiselect-dropdown>
          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.customer_id, value:createForm.controls.customer_id, submitted:createFormSubmitted }"
            >
          </ng-template>
        </div>
      </div>
      
      <!-- Responsible -->
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ lang?.responsible }}</label>
        </div>
        <div class="form-group col-sm-9">
          <!-- <input type="text" class="form-control" formControlName="emp_id"
            [ngClass]="formErrorClass(createForm.controls.emp_id, createFormSubmitted)"> -->
          <select class="form-control" formControlName="emp_id" [ngClass]="formErrorClass(createForm.controls.emp_id, createFormSubmitted)">
            <option selected>Select</option>
            <option *ngFor="let resp of data?.employees" [value]="resp?.employeeId"> {{ resp?.employee_name }} </option>
          </select>
          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.emp_id, value:createForm.controls.emp_id, submitted:createFormSubmitted }"
            >
          </ng-template>
        </div>
      </div>         
      
      <!-- Start Date -->
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ lang?.startDate }}</label>
        </div>
        <div class="form-group col-sm-9">
          <input type="date" class="form-control" formControlName="start_date"
            [ngClass]="formErrorClass(createForm.controls.start_date, createFormSubmitted)">
          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.start_date, value:createForm.controls.start_date, submitted:createFormSubmitted }"
            >
          </ng-template>
        </div>
      </div>  

      <!-- Expected delivery date -->
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ lang?.expected_delivery_date }}</label>
        </div>
        <div class="form-group col-sm-9">
          <input type="date" class="form-control" formControlName="d_date"
            [ngClass]="formErrorClass(createForm.controls.d_date, createFormSubmitted)">
          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.d_date, value:createForm.controls.d_date, submitted:createFormSubmitted }"
            >
          </ng-template>
        </div>
      </div> 
      
      <!-- Offer -->
      <!-- <div class="form-group col-sm-12" >
        <div class="form-group col-sm-3">
          <label>{{ lang?.offer }}</label>
        </div>
        <div class="form-group col-sm-9">
          <input type="text" class="form-control" formControlName="offer"
            [ngClass]="formErrorClass(createForm.controls.offer, createFormSubmitted)">
          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.offer, value:createForm.controls.offer, submitted:createFormSubmitted }"
            >
          </ng-template>
        </div>
      </div>   -->

      <div class="col-sm-12" formArrayName="timetable_link">
        <div class="col-sm-3">
        <label>{{lang?.offer}}</label>
      </div>
      <div class="col-sm-9">
        <div class="form-group row" *ngFor="let link of timetable_link().controls; let i = index;" [formGroupName]="i">
          <div class="col-sm-11">
            <input type="file" class="filestyle" data-buttonText="Choose file" (change)="selectAttachment($event,i)" formControlName="link">

            <ng-template [ngTemplateOutlet]="ErrorMsg" [ngTemplateOutletContext]="{msg:createFormErrorMsg.timetable_link, value:timetable_link().controls[i].controls['link'], submitted:createFormSubmitted }"></ng-template>

          </div>
          <div class="col-sm-1">
            <button class="btn btn-primary pull-right" type="button" (click)="removeAttachment(i)" *ngIf=" i!=(timetable_link().controls.length-1) ">
              <i class="fa fa-trash-o"></i>
            </button>
            <button class="btn btn-primary pull-right" type="button" (click)="addAttachment()" *ngIf=" i==(timetable_link().controls.length-1) ">
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>
      </div>
      </div>

      <div class="col-sm-12" formArrayName="offer_link_uploaded">
        <div class="col-sm-3">
        </div>
        <div class="col-sm-9">
        <div class="form-group row" *ngFor="let image of offer_link_uploaded().controls; let i=index">
          <div class="col-sm-11">
            <input type="hidden" class="form-control" formControlName="{{i}}">
            <input type="hidden" class="filestyle" data-buttonText="Choose file" (change)="selectAttachment($event,i)" value="{{image.value.split('/').pop()}}">
            <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/deadline_image/{{image.value.split('/').pop()}}" target="_blank">{{image.value.split('/').pop()}}</a>
          </div>
          <div class="col-sm-1">
            <button class="btn btn-primary pull-right" type="button" (click)="removeOfferAttachmentUploaded(i)">
              <i class="fa fa-trash-o"></i>
            </button>
          </div>
        </div>
      </div>
      </div>          
      

      <div class="col-sm-12" formArrayName="timetable_link">
        <div class="col-sm-3">
        <label>{{lang?.contract}}</label>
      </div>
      <div class="col-sm-9">
        <div class="form-group row" *ngFor="let link of timetable_link().controls; let i = index;" [formGroupName]="i">
          <div class="col-sm-11">
            <input type="file" class="filestyle" data-buttonText="Choose file" (change)="selectAttachment($event,i)" formControlName="link">

            <ng-template [ngTemplateOutlet]="ErrorMsg" [ngTemplateOutletContext]="{msg:createFormErrorMsg.timetable_link, value:timetable_link().controls[i].controls['link'], submitted:createFormSubmitted }"></ng-template>

          </div>
          <div class="col-sm-1">
            <button class="btn btn-primary pull-right" type="button" (click)="removeAttachment(i)" *ngIf=" i!=(timetable_link().controls.length-1) ">
              <i class="fa fa-trash-o"></i>
            </button>
            <button class="btn btn-primary pull-right" type="button" (click)="addAttachment()" *ngIf=" i==(timetable_link().controls.length-1) ">
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>
      </div>
      </div>

      <div class="col-sm-12" formArrayName="timetable_link_uploaded">
        <div class="col-sm-3">
        </div>
        <div class="col-sm-9">
        <div class="form-group row" *ngFor="let image of timetable_link_uploaded().controls; let i=index">
          <div class="col-sm-11">
            <input type="hidden" class="form-control" formControlName="{{i}}">
            <input type="hidden" class="filestyle" data-buttonText="Choose file" (change)="selectAttachment($event,i)" value="{{image.value.split('/').pop()}}">
            <a href="http://vmi313621.contaboserver.net/Software_backend/uploads/deadline_image/{{image.value.split('/').pop()}}" target="_blank">{{image.value.split('/').pop()}}</a>
          </div>
          <div class="col-sm-1">
            <button class="btn btn-primary pull-right" type="button" (click)="removeAttachmentUploaded(i)">
              <i class="fa fa-trash-o"></i>
            </button>
          </div>
        </div>
      </div>
      </div>    

      <!-- Project Amount -->
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ lang?.project_amount }}</label>
        </div>
        <div class="form-group col-sm-9">
          <input type="text" class="form-control" formControlName="amount"
            [ngClass]="formErrorClass(createForm.controls.amount, createFormSubmitted)">
          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.amount, value:createForm.controls.amount, submitted:createFormSubmitted }"
            >
          </ng-template>
        </div>
      </div>  
      
      <!-- hours -->
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ lang?.expectedHours }}</label>
        </div>
        <div class="form-group col-sm-9">
          <input type="text" class="form-control" formControlName="hours"
            [ngClass]="formErrorClass(createForm.controls.hours, createFormSubmitted)">
          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.hours, value:createForm.controls.hours, submitted:createFormSubmitted }"
            >
          </ng-template>
        </div>
      </div>  
      
      <!-- Project Class -->
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ lang?.projectClass }}</label>
        </div>
        <div class="form-group col-sm-9">
            <select class="form-control" id="class_id" formControlName="class_id" (change)="getProjectVal()" [ngClass]="formErrorClass(createForm.controls.class_id, createFormSubmitted)">
              <option selected>Select</option>
              <option *ngFor="let project of projectList" [attr.data-category]="project?.category" [value]="project?.class_id"> {{ project?.description }} </option>
            </select>            
          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.class_id, value:createForm.controls.class_id, submitted:createFormSubmitted }"
            >
          </ng-template>
        </div>
      </div>        
      
      <!-- Project Category -->
      <div class="form-group col-sm-12">
        <div class="form-group col-sm-3">
          <label>{{ lang?.projectCategory }}</label>
        </div>
        <div class="form-group col-sm-9">
          <input type="text" class="form-control" formControlName="class_category" id="class_category" disabled
            [ngClass]="formErrorClass(createForm.controls.class_category, createFormSubmitted)">
          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:createFormErrorMsg.class_category, value:createForm.controls.class_category, submitted:createFormSubmitted }"
            >
          </ng-template>
        </div>
      </div>        

    </div>
  </div>

  <div class="modal-footer">
    <button type="submit" class="btn btn-success">{{ lang?.save }}</button>
    <!-- <button class="btn btn-warning" data-dismiss="modal" (click)="bsModalRef.hide()">Close</button> -->
    <button type="button" class="btn btn-warning" (click)="bsModalRef.hide()">{{ lang?.close }}</button>

  </div>
</form>

<ng-template #imagePreviewRef let-link='imageLink'>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Image Preview</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body section-spaces">
    <app-image-preview [imageUrl]="imageLink"></app-image-preview>
  </div>
</ng-template>